export default "__VITE_ASSET__52965944__"